<template>
  <div class="statistics-date-range__ranges-list">
    <button @click.prevent="onCustomClick"
            :class="{_active: !selectedDateRangeType}"
            class="statistics-date-range__ranges-list-btn  base-btn  base-btn--outline-dark">
      {{ $tStatistic('range_custom') }}
    </button>
    <button v-for="key in ranges"
            :key="key"
            @click.prevent="onClick(key)"
            :class="{_active: selectedDateRangeType === key}"
            class="statistics-date-range__ranges-list-btn  base-btn  base-btn--outline-dark">
      {{ $tStatistic(`range_${key}`) }}
    </button>
  </div>
</template>

<script>
  import {DateTime} from "luxon";

  export default {
    name: 'StatisticsPageDatesRangeRangesList',
    inject: [
      'FILTER_DATE_FROM',
      'FILTER_DATE_TO',
      'DATE_RANGE_TYPE_KEY',
      'formatDate',
    ],
    data() {
      return {
        ranges: [
          'week',
          'ten_days',
          'months',
          'quarter',
          'year',
          'all',
        ]
      }
    },
    computed: {
      selectedDateRangeType() {
        return this.$route.query[this.DATE_RANGE_TYPE_KEY]
      },
    },
    methods: {
      onClick(key) {
        const now = DateTime.now()
        let from

        switch (key) {
          case 'week':
            from = now.minus({week: 1})
            break
          case 'ten_days':
             from = now.minus({day: 10})
            break
          case 'months':
             from = now.minus({month: 1})
            break
          case 'quarter':
             from = now.minus({quarter: 1})
            break
          case 'year':
             from = now.minus({year: 1})
            break
          case 'all':
            break
        }

        const query = {
          ...this.$route.query,
        }

        if(key === 'all') {
          delete query[this.FILTER_DATE_FROM]
          delete query[this.FILTER_DATE_TO]
        } else {
          query[this.FILTER_DATE_FROM] = this.formatDate.format(from)
          query[this.FILTER_DATE_TO] = this.formatDate.format(now)
        }

        query[this.DATE_RANGE_TYPE_KEY] = key


        this.$router.push({
          query
        }).catch(() => ({}))
      },

      onCustomClick() {
        const query = {
          ...this.$route.query,
        }

        delete query[this.FILTER_DATE_FROM]
        delete query[this.FILTER_DATE_TO]
        delete query[this.DATE_RANGE_TYPE_KEY]

        this.$router.push({
          query
        }).catch(() => ({}))
      }

      // getDefaultDateRangeFromDate(current) {
      //   const from = new Date(current.getFullYear() - 1, current.getMonth(), current.getDate())
      //   const to = new Date(current.getFullYear(), current.getMonth(), current.getDate())
      //
      //   return [formatDate.format(from), formatDate.format(to)]
      // }
    }
  }
</script>

<style lang="less">

</style>
